import styled from 'styled-components'

import { Type } from '../../../theme/types/generic.interface'

export const ImageMarketPlace = styled.section`
  ${({ theme }: Type) => theme?.marketplaces?.border}
`
